/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Value kind: a scalar string or a list of strings.
 */
export const ActorAttributeType = {
  String: "string",
  List: "list",
} as const;
/**
 * Value kind: a scalar string or a list of strings.
 */
export type ActorAttributeType = ClosedEnum<typeof ActorAttributeType>;

export type ActorAttribute = {
  /**
   * Human-readable description of the attribute.
   */
  description: string;
  /**
   * Attribute name as used in target conditions, e.g. department_name.
   */
  name: string;
  /**
   * Value kind: a scalar string or a list of strings.
   */
  type: ActorAttributeType;
};

/** @internal */
export const ActorAttributeType$inboundSchema: z.ZodMiniEnum<
  typeof ActorAttributeType
> = z.enum(ActorAttributeType);

/** @internal */
export const ActorAttribute$inboundSchema: z.ZodMiniType<
  ActorAttribute,
  unknown
> = z.object({
  description: z.string(),
  name: z.string(),
  type: ActorAttributeType$inboundSchema,
});

export function actorAttributeFromJSON(
  jsonString: string,
): SafeParseResult<ActorAttribute, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ActorAttribute$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ActorAttribute' from JSON`,
  );
}
